import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <Link to="/">
              <h1>707 M CO., LTD.</h1>
            </Link>
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                  หน้าหลัก
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                  เกี่ยวกับเรา
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                  ติดต่อเรา
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/privacy" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                  นโยบายความเป็นส่วนตัว
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/terms" className="nav-link" onClick={() => setIsMobileMenuOpen(false)}>
                  เงื่อนไขการใช้บริการ
                </Link>
              </li>
            </ul>
          </nav>
          
          <button 
            className="mobile-menu-toggle" 
            onClick={toggleMobileMenu}
            aria-label="สลับเมนูบนมือถือ"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
